export const TravelFormConstants = {
  PRELIMINARY: "Preliminary",
  SUBMITTED: "Submitted",
  APPROVED: "Approved",
  REJECTED: "Rejected",
  GUARDIAN_DOCS_TYPE_ID: 46
};
